export interface RawPageInfoResponse {
  next_cursor?: string | null;
  prev_cursor?: string | null;

  total_count?: number | null;
}

export interface PageInfo {
  nextCursor?: string;
  prevCursor?: string;

  totalCount?: number;
}

export function rawPageInfoResponseToPageInfo(rawPageInfo?: RawPageInfoResponse): PageInfo {
  return {
    nextCursor: rawPageInfo?.next_cursor ?? undefined,
    prevCursor: rawPageInfo?.prev_cursor ?? undefined,
    totalCount: rawPageInfo?.total_count ?? undefined,
  };
}
